import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

function ChannelPrice({component = 'span', className, price, currency}) {
  const Component = component;

  return (
    <Component className={className}>
      {ChannelPrice.formatCurrencySymbol(currency)}
      {ChannelPrice.formatPrice(currency, price)}
    </Component>
  );
}

ChannelPrice.propTypes = {
  price: PropTypes.number.isRequired
};

ChannelPrice.formatPrice = (currency, price) => {
  const priceString = parseFloat((price / (10 ** currency.fractionDigits)).toFixed(currency.fractionDigits)).toString();

  let splitByFraction = priceString.split('.');
  splitByFraction[0] = splitByFraction[0].split(/(?=(?:...)*$)/).join(' ');

  return splitByFraction.join('.');
};

ChannelPrice.formatCurrencyCode = (currency) => currency.code;
ChannelPrice.formatCurrencySymbol = (currency) => currency.symbol;

export default connect(
  ({channels}, {channel}) => ({currency: channels.availableChannels[channel || channels.activeChannel].baseCurrency})
)(ChannelPrice);



// WEBPACK FOOTER //
// ./containers/channelUtils/ChannelPrice.js